
define('app',[
    // Libraries
    "jquery",
    "lodash",
    "backbone",
    "jqueryMigrate",
    "googleFonts",
    "json2",

    //Dictionaries
    "dictionaries/en",
    "dictionaries/it",
    "dictionaries/fr",
    "dictionaries/mar",

    // Plugins
    "plugins/backbone.layoutmanager",
    "plugins/jquery-i18n-min",
    "plugins/jquery-flexslider",
    //Configuration
    "configurations/conf"
  ],

  function($, _, Backbone) {

    $.curCSS = function(element, attrib, val) {
      $(element).css(attrib, val);
    };

    window.isBrowserCompatibleWithAnimation = function() {
      if ('WebkitTransform' in document.body.style || 'MozTransform' in document.body.style || 'OTransform' in document.body.style || 'transform' in document.body.style)
        return true;
      else
        return false;
    };

    Backbone.Layout.configure({
      manage: true
    });

    Backbone.View.prototype.close = function() {
      this.remove();
      this.unbind();
      if (this.onClose) {
        this.onClose();
      }
    };

    if (typeof String.prototype.endsWith !== 'function') {
      String.prototype.endsWith = function(suffix) {
        return this.indexOf(suffix, this.length - suffix.length) !== -1;
      };
    }

    // Provide a global location to place configuration settings and module
    // creation.
    var app = {
      // The root path to run the application through.
      root: "/"
    };

    // Localize or create a new JavaScript Template object.
    var JST = window.JST = window.JST || {};

    // Configure LayoutManager with Backbone Boilerplate defaults.
    Backbone.Layout.configure({
      prefix: "app/templates/",

      fetch: function(path) {
        path = path + ".html";

        if (!JST[path]) {
          $.ajax({
            url: "/" + path,
            async: false
          }).then(function(contents) {
            JST[path] = _.template(contents);
          });
        }

        return JST[path];
      }
    });

    var resizeTimer;
    $(window).resize(function() {
      if (resizeTimer)
        clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
          if ($('#cboxOverlay').is(':visible')) {
            $.colorbox.load(true);
          }
        },
        300);
    });

    // Mix Backbone.Events, modules, and layout management into the app object.
    return _.extend(app, {
      // Create a custom object with a nested Views object.
      module: function(additionalProps) {
        return _.extend({
          Views: {}
        }, additionalProps);
      },

      // Helper for specific layouts.
      useLayout: function(name) {
        // If already using this Layout, then don't re-inject into the DOM.
        if (this.layout && this.layout.options.template === name) {
          return this.layout;
        }

        // If a layout already exists, remove it from the DOM.
        if (this.layout) {
          this.layout.remove();
        }

        // Create a new Layout.
        var layout = new Backbone.Layout({
          template: name,
          className: "layout " + name,
          id: "layout"
        });

        // Insert into the DOM.
        $("#main").empty().append(layout.el);

        // Render the layout.
        layout.render();

        // Cache the reference on the Router.
        this.layout = layout;

        // Return the reference, for later usage.
        return layout;
      }
    }, Backbone.Events);

  });